<template>
    <textarea :rows="rows" class="form-control" :placeholder="placeholder" :value="value" ref="txtArea" @change="updateContent" :name="name"></textarea>
</template>

<script>
import autosize from 'autosize'
export default {
  components: {
    autosize
  },
  props: {
    name: {
      required: true
    },
    value: {
      default: ''
    },
    rows: {
      default: 1
    },
    placeholder: {
      default: ''
    }
  },
  mounted () {
  },
  methods: {
    updateContent () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// autosize-textarea.vue?53f61e00